var Shopify = Shopify || {};

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

let lastWindowWidth = window.innerWidth;

function handleResize() {
    const currentWindowWidth = window.innerWidth;

    // Check if the width has significantly changed (e.g., moving from desktop to mobile)
    if (Math.abs(currentWindowWidth - lastWindowWidth) > 100) {
        adjustHeightSearch();
        lastWindowWidth = currentWindowWidth;  // Update the width reference
    }
}

// Run on document ready
document.addEventListener("DOMContentLoaded", function() {
    adjustHeightSearch();
});

// Run on window resize, but only if the width has significantly changed
window.addEventListener("resize", function() {
    handleResize();
});

function adjustHeightSearch(){
  if(window.innerWidth < 990){
    let total_height = document.querySelectorAll('.shopify-section-group-header-group')[0].offsetHeight+document.querySelectorAll('.shopify-section-group-header-group')[1].offsetHeight
    document.querySelector('.custom-search .search__wrapper').style.maxHeight = `calc(100vh - ${total_height}px)`
  }
}

function hideLoader(){
  document.querySelector('.search__button .spinner').style.display = 'none';
  document.querySelector('.search__button .icon').style.display = 'block';
}

function showLoader(){
  document.querySelector('.search__button .spinner').style.display = 'block';
  document.querySelector('.search__button .icon').style.display = 'none';
}

function showSearch() {
  document.body.classList.add('hide-overflow');
  hideLoader()
  try {
    $('.search__wrapper').stop(true, true).slideDown(300);
  } catch (e) {
    document.querySelector('.search__wrapper').style.display = 'block';
  }
  document.querySelector('.custom-search').classList.add('active');
}

function hideSearch() {
  document.querySelector('.custom-search').classList.remove('active');
  hideLoader()
  try {
    $('.search__wrapper').stop(true, true).slideUp(300);
  } catch (e) {
    document.querySelector('.search__wrapper').style.display = 'none';
  }
  document.body.classList.remove('hide-overflow');
}

function customDebounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

function getResults() {
  const query = document.getElementById('Search-In-Modal').value;

  if (query) {
    fetch(`/search/suggest.json?q=${query}&resources[type]=query,product,collection,page,article&resources[limit]=9&resources[limit_scope]=each`)
      .then(response => response.json())
      .then(data => {
        const results = data.resources.results;

        let suggestionsHTML = '';
        if (results.queries.length > 0) {
          suggestionsHTML = results.queries
            .slice(0, 3)
            .map(query => `<li><a href="${query.url}">${query.styled_text}</a></li>`)
            .join('');
        } else {
          suggestionsHTML = '<li>No suggestions found</li>';
        }
        document.querySelectorAll('.search__side .el ul')[0].innerHTML = suggestionsHTML;

        let collectionsHTML = '';
        if (results.collections.length > 0) {
          collectionsHTML = results.collections
            .slice(0, 4)
            .map(collection => `<li><a href="${collection.url}">${collection.title}</a></li>`)
            .join('');
        } else {
          collectionsHTML = '<li>No categories found</li>';
        }
        document.querySelectorAll('.search__side .el ul')[1].innerHTML = collectionsHTML;

        let productsHTML = '';
        if (results.products.length > 0) {
          document.querySelector('.custom-search .container').style.display = 'flex';
          productsHTML = results.products
            .slice(0, 9)
            .map(product => `
              <div class="elem__product">
                <a href="${product.url}" class="media">
                  <img src="${product.featured_image.url.replace('.jpg', '_280x.jpg').replace('.png', '_280x.png')}" alt="${product.featured_image.alt}">
                </a>
                <div class="desc">
                  <a href="${product.url}">${product.title}</a>
                  <span>From £${product.price_min || product.price}</span>
                </div>
              </div>
            `)
            .join('');
        } else {
          productsHTML = '<p>No products found</p>';
          document.querySelector('.custom-search .container').style.display = 'block';
        }
        document.querySelector('.search__products .products__grid').innerHTML = productsHTML;
        showSearch();
      })
      .catch(error => console.error('Error fetching search results:', error));
  } else {
    hideSearch();
  }
}

const debouncedSearch = customDebounce(getResults, 300);
document.getElementById('Search-In-Modal').addEventListener('input', function(e){
  e.preventDefault();
  debouncedSearch()
  showLoader()
});

document.querySelector('.search__wrapper .close_button').addEventListener('click', function(e){
  e.preventDefault();
  hideSearch();
});

document.getElementById('Search-In-Modal').addEventListener('click', function(e){
  e.preventDefault();
  if (this.value !== '') {
    showSearch();
  }
});

document.querySelector('.custom-search .overlay').addEventListener('click', function(e){
  e.preventDefault();
  hideSearch();
});

document.querySelector('.custom-search .search__wrapper .outer__search .search__products > .head > a').addEventListener('click', function(e){
  e.preventDefault();
  document.querySelector('.custom-search form.search.search-modal__form').submit();
});
